<span *ngIf="isToday; else today" class="date">{{ date | amFromUtc | amLocal | amCalendar }}</span>
<ng-template #today>
  <span class="date">{{ date | date }}</span>
</ng-template>